import React from "react";

const ReturnPolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-6 md:px-20 text-gray-800">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8 md:p-12">
        <h1 className="text-3xl font-bold text-center text-indigo-700 mb-6">
          Cookie Policy & Legal Disclaimer
        </h1>

        {/* Legal Disclaimer */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            A Legal Disclaimer
          </h2>
          <p className="leading-relaxed mb-4">
            The explanations and information provided on this page are only
            general and high-level explanations and information on how to write
            your own document of a Cookie Policy. You should not rely on this
            article as legal advice or as recommendations regarding what you
            should actually do, because we cannot know in advance what are your
            specific cookie-related practices.{" "}
            <strong>
              We recommend that you seek legal advice to help you understand and
              to assist you in the creation of your own Cookie Policy.
            </strong>
          </p>
        </section>

        {/* Cookie Policy - The Basics */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            Cookie Policy — The Basics
          </h2>
          <p className="leading-relaxed mb-4">
            Having said that, in certain jurisdictions, you must inform your
            site visitors in case your website tracks personal information
            through the use of cookies or similar technologies. In these
            jurisdictions, local regulations often include an obligation to be
            clear about what tracking tools (e.g. cookies, flash cookies, web
            beacons, etc.) your website deploys, and what types of personal
            information these technologies gather. These policies often also
            tell website visitors what the website is doing with the information
            collected.
          </p>
        </section>

        {/* Third-party Cookies */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            Third-Party Cookies & External Services
          </h2>
          <p className="leading-relaxed mb-4">
            It's important to note that third-party services placing cookies or
            utilizing other tracking technologies through a platform (such as
            Wix or others) may have their own policies regarding how they
            collect and store information. As these are external services, such
            practices are not covered by the Sridanth Privacy Policy or Cookie
            Policy.
          </p>
        </section>

        {/* Learn More */}
        <section>
          <h2 className="text-2xl font-semibold text-indigo-600 mb-3">
            Learn More
          </h2>
          <p className="leading-relaxed">
            To learn more about this topic, we recommend reading the article{" "}
            <em>“Cookies and Your Wix Site.”</em> You may also wish to consult
            with a qualified legal professional to ensure your policy complies
            with applicable privacy and data protection laws.
          </p>
        </section>
      </div>
    </div>
  );
};

export default ReturnPolicy;
